import { Component } from '@theme/component';

/**
 * Powers the "THIRD Spaceについて" page: scroll-triggered fade-in reveal,
 * continuous scroll parallax on photos, and the closing store-photo hover link.
 * Respects prefers-reduced-motion (both effects become inert; content is
 * simply visible, no animation).
 *
 * @extends {Component}
 */
class ThirdSpaceAboutComponent extends Component {
  requiredRefs = [];

  connectedCallback() {
    super.connectedCallback();

    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.#setupReveal();
    this.#setupParallax();
  }

  #setupReveal() {
    const items = /** @type {Element[]} */ (this.refs.revealItems || []);
    if (!items.length) return;

    if (this.reducedMotion || typeof IntersectionObserver === 'undefined') {
      items.forEach((item) => item.classList.add('in-view'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        }
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    items.forEach((item) => observer.observe(item));
  }

  #setupParallax() {
    const items = /** @type {HTMLElement[]} */ (this.refs.parallaxItems || []);
    if (!items.length || this.reducedMotion) return;

    let ticking = false;

    const update = () => {
      ticking = false;
      const viewportCenter = window.innerHeight / 2;

      for (const item of items) {
        const rect = item.getBoundingClientRect();
        const itemCenter = rect.top + rect.height / 2;
        const distance = itemCenter - viewportCenter;
        const shift = Math.max(-26, Math.min(26, distance * -0.04));
        item.style.transform = `translateY(${shift}px)`;
      }
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }
}

if (!customElements.get('third-space-about')) {
  customElements.define('third-space-about', ThirdSpaceAboutComponent);
}
